import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 * Instantly jumps to the top of the viewport whenever the route changes.
 * Skips if the URL has a hash (in-page anchor).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchor links behave normally
    // Use auto (instant) so users never see a scroll transition on nav
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
